import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import SessionManager from "../Utils/Session";

const SubAdminService = {
    // Existing login function
    getAllRoles: async (offset, limit, searchQuery) => {
        try {
            let url = ApiConstants.getAllRoles + `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}`;

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                },
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },

    getAllSubAdmins: async (offset, limit, searchQuery) => {
        try {
            const response = await axios.get(
                ApiConstants.getAllsubAdmins +
                `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}`,
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                }
            );

            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },
    getAllRolesWithoutPagination: async () => {
        try {
            const response = await axios.get(
                ApiConstants.getAllRoleList,
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },

    deleteRole: async (id) => {
        try {
            const response = await axios.post(ApiConstants.deleteRole, {
                id: id
            },
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },
    deleteSingleSubAdmin: async (id) => {
        try {
            const response = await axios.post(ApiConstants.deleteSingleSubAdmin, {
                id: id
            },
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },

    editRole: async (id, roleName, role_type,) => {
        try {
            const response = await axios.put(ApiConstants.editRole, {
                id: id,
                roleName: roleName,
                role_type: role_type
            }, {
                headers: {
                    Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                },
            });
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },

    addRole: async ({ role_id, roleName, role_type }) => {
        try {
            const response = await axios.post(
                ApiConstants.addRole, {
                role_id: role_id||"",
                roleName: roleName,
                role_type: role_type
            }, {
                headers: {
                    Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                },
            }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },
    addSubAdmin: async ({ admin_id, name, email, role_id,mobileNumber }) => {
        try {
            const response = await axios.post(
                ApiConstants.addSubAdmin, {
                admin_id: admin_id,
                name: name,
                email: email,
                role_id: role_id,
                mobileNumber: mobileNumber
            }, {
                headers: {
                    Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                },
            }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },
    updateRoleStatus: async (id, status) => {
        try {
            const response = await axios.put(
                ApiConstants.updateRoleStatus,
                {
                    id: id,
                    is_active: status,
                },
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                }
            );

            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },
    updateSubAdminStatus: async (id, status) => {
        try {
            const response = await axios.put(
                ApiConstants.updateSubAdminStatus,
                {
                    id: id,
                    is_active: status,
                },
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                }
            );

            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    },
    updateRolePrivileges: async (role_id, privilegesToSend) => {
        try {
            const response = await axios.post(
                ApiConstants.updateRolePrivileges, {
                roleId: role_id,
                setPrivileges: privilegesToSend
            },
                {
                    headers: {
                        Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(response.error);
            }
        } catch (error) {
            throw error;
        }
    }


    
}

export default SubAdminService;
